import { Injectable, OnInit, EventEmitter } from '@angular/core';
import { AcademicYears, AcademicPeriods, AcademicSemesters } from '../../_models';
import * as _ from 'lodash';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CreateAcademicYears } from '../../_models/system-setting/academic-year-manage/create-academic-years.interface';
import { UpdateAcademicYears } from '../../_models/system-setting/academic-year-manage/update-academic-years.interface';
import { CreateAcademicSemesters } from '../../_models/system-setting/academic-year-manage/create-academic-semesters.interface';
import { UpdateAcademicSemesters } from '../../_models/system-setting/academic-year-manage/update-academic-semesters.interface';
import { Company } from 'src/app/_models/common/company-Interface.interface';

@Injectable({
  providedIn: 'root'
})
export class AcademicYearsService {
  academicYears: AcademicYears[] = [];
  notifier = new EventEmitter();
 
  private url: string;

  constructor(public http: HttpClient) {
    this.url = `${environment.apiUrl}AcademicYear`;
  }

  getAll() {
    return this.http.get(`${this.url}/GetAllAcademicYear`);
  }

  getAllLookups() {
    return this.http.get(`${this.url}/GetAcademicYearSemester`);
  }
  getById(id: number) {
    return this.http.get(`${this.url}/GetAcademicYear/${id}`);
  }

  insert(items: CreateAcademicYears) {
    return this.http.post(`${this.url}/CreateAcademicYear`, items);
  }

  update(items: UpdateAcademicYears) {
    return this.http.put(`${this.url}/UpdateAcademicYear`, items);
  }

  delete(items: AcademicYears) {
    return this.http.delete(`${this.url}/DeleteAcademicYear/${items.academicYearId}`);
  }

  setnewData(items: AcademicYears[]) {
    this.academicYears = _.cloneDeep(items);
    this.notifier.emit(this.academicYears);
  }

  getCurrentData() {
    return this.academicYears;
  }

  insertedData(items: AcademicYears) {
    this.academicYears.unshift(items);
    this.notifier.emit(this.academicYears);
    
  }
  updateData(items: AcademicYears ){
     let  i = this.academicYears.findIndex( f=>f.academicYearId == items.academicYearId);
      if(i!=-1)
      {
        this.academicYears[i]= _.cloneDeep( items);
        this.notifier.emit(this.academicYears);
      }
   
  }

  updateAcData(items: AcademicYears ){
    let  i = this.academicYears.findIndex( f=>f.academicYearId == items.academicYearId);
     if(i!=-1)
     {
       this.academicYears[i].isClosed= items.isClosed;
       this.academicYears[i].studentsEndDate= items.studentsEndDate;
       this.academicYears[i].studentsStartDate= items.studentsStartDate;
       this.academicYears[i].managementEndDate= items.managementEndDate;
       this.academicYears[i].managementStartDate= items.managementStartDate;
       this.academicYears[i].teachersEndDate= items.teachersEndDate;
       this.academicYears[i].teachersStartDate= items.teachersStartDate;
       this.academicYears[i].winterTimingEndDate= items.winterTimingEndDate;
       this.academicYears[i].winterTimingStartDate= items.winterTimingStartDate;
       this.academicYears[i].name= items.name;
       this.academicYears[i].nameEn= items.nameEn;
       this.notifier.emit(this.academicYears);
     }
  
 }
  deleteData(items: AcademicYears ){
    let  i = this.academicYears.findIndex( f=>f.academicYearId == items.academicYearId);
     if(i!=-1)
     {
    
       this.academicYears.splice(i,1);
       this.notifier.emit(  this.academicYears)
     }
  
 }

}

@Injectable({
  providedIn: 'root'
})
export class AcademicSemestersService {
  private url: string;
  private urlApi: string;

  constructor(public http: HttpClient) {
    this.url = `${environment.apiUrl}AcademicYear`;
    this.urlApi = `${environment.apiUrl}`;
  }

  getAllByYearId(id: number) {
    return this.http.get(`${this.url}/GetAllAcademicSemester/${id}`);
  }

  getById(id: number) {
    return this.http.get(`${this.url}/GetAcademicSemester/${id}`);
  }

  insert(items: CreateAcademicSemesters) {
    return this.http.post(`${this.url}/CreateAcademicSemester`, items);
  }

  update(items: UpdateAcademicSemesters) {
    return this.http.put(`${this.url}/UpdateAcademicSemester`, items);
  }

  delete(items: AcademicSemesters) {
    return this.http.delete(
      `${this.url}/DeleteAcademicSemester/${items.academicSemesterId}`
    );
  }
  createCompany(obj: Company) {
    return this.http.post(`${this.urlApi}Company/CreateCompany`, obj);
  }
}
